// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--deoqN","active":"_7a3fb80146--active--UMHOw","title":"_7a3fb80146--title--EDEFD","labels":"_7a3fb80146--labels--NP710"};